import { ComponentsProps, ComponentsOverrides, ComponentsVariants, Theme, Palette, PaletteColor } from '@mui/material';
import { baseTheme } from '../base-theme';
import { TileProps } from '../../components/tile';

export const CaroteneTile: {
    defaultProps?: ComponentsProps['CaroteneTile'];
    styleOverrides?: ComponentsOverrides<Theme>['CaroteneTile'];
    variants?: ComponentsVariants['CaroteneTile'];
} = {
    defaultProps: {
        color: 'default',
    },
    variants: [
        { props: { color: 'default' }, style: { backgroundColor: baseTheme.palette.background.default } },
        ...Object.keys(baseTheme.palette)
            .filter((key) => (baseTheme.palette[key as keyof Palette] as PaletteColor).light)
            .map((color) => ({
                props: { color: color as TileProps['color'] },
                style: {
                    backgroundColor: (baseTheme.palette[color as keyof Palette] as PaletteColor).light,
                },
            })),
    ],
    styleOverrides: {
        root: (props) => ({
            padding: props.theme.spacing(props.theme.tokens.spacing.lg),
            borderRadius: props.theme.borderRadius(props.theme.tokens.borderRadius.md),
        }),
    },
};
